exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[src=\"\"]{display:none}.icon-danger i{color:red}#main #content{margin-top:66px}#main #content .page-title h3{font-size:1.25rem;text-transform:uppercase;padding-top:5px}.form-control.is-valid:focus,.was-validated .form-control:valid:focus{color:#495057;background-color:#fff;border-color:#a1cbef;outline:0;box-shadow:0 0 0 .2rem rgba(52,144,220,.25)}.form-control.is-valid,.was-validated .form-control:valid{border-color:#ddd;background-image:none}", ""]);

// exports
